import AssignPercentagesError from './AssignPercentagesError';
class InvalidPercentage extends AssignPercentagesError {
    constructor(options) {
        super('The percentage must be a valid number between 0 and 1', options);
    }
}
export default InvalidPercentage;
